module.exports = __webpack_public_path__ + "img/ug333.12fb5329.png";